module.exports = __webpack_public_path__ + "img/symbol_12.65438fc8.png";